<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/xuqiu/Lmanagement',title:'协同管理'},{title:'协同部门配置'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                          <el-form-item label="订单编号" prop="cgCode" style="width: 50%;">
                            <el-input v-model="q.code" placeholder="多订单模糊查询请用空格或分号分隔"></el-input>
                          </el-form-item>
                            <el-form-item label="创建时间" prop="cdate" style="width: 50%;">
                              <el-date-picker
                                  v-model="q.staDate"
                                  clearable
                                  type="date"
                                  value-format="yyyy-MM-dd" >
                              </el-date-picker>
                              <span class="w-time-to">至</span>
                              <el-date-picker
                                  v-model="q.endDate"
                                  clearable
                                  type="date"
                                  value-format="yyyy-MM-dd" >
                              </el-date-picker>
                            </el-form-item>
                        </div>
                      <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="销售订单号" prop="cgCode" style="width: 50%;">
                          <el-input v-model="q.orderCode" placeholder="多订单模糊查询请用空格或分号分隔"></el-input>
                        </el-form-item>
                        <el-form-item label="预测单号" >
                          <el-input v-model="q.ycId" placeholder="请输入" :clearable="true"></el-input>
                        </el-form-item>
                        <el-form-item label="供应商" >
                          <el-input v-model="q.sUserName" placeholder="请输入名称/编码" :clearable="true"></el-input>
                        </el-form-item>

                      </div>
                      <div class="l-screenBox">
                        <div class="l-retrieval">
                          <el-form-item>
                            <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                            </el-button>
                          </el-form-item>
                        </div>
                      </div>
                    </el-form>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table @selection-change="handleSelectionChange"
                              ref="multipleTable"
                              :data="tableData"
                              :border="true"
                              stripe
                              max-height="500"
                              style="width: 100%">
                        <el-table-column
                                type="selection"
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="code"
                                label="采购订单号"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="orderCode"
                                width="120"
                                :show-overflow-tooltip="true"
                                label="销售订单号">
                        </el-table-column>
                        <el-table-column
                                prop="type"
                                :show-overflow-tooltip="true"
                                width="100"
                                label="订单类型">
                          <template slot-scope="scope">
                            <div>
                              <span v-if="scope.row.type == 1">内销</span>
                              <span v-if="scope.row.type == 2">外销</span>
                              <span v-if="scope.row.type == 3">上海</span>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column
                                prop="ycId"
                                :show-overflow-tooltip="true"
                                width="120"
                                label="预测单号">
                        </el-table-column>
                        <el-table-column
                                prop="status"
                                :show-overflow-tooltip="true"
                                width="110"
                                label="订单状态">
                          <template slot-scope="scope">
                            <div>
                              <span v-if="scope.row.status == 1">待审核</span>
                              <span v-if="scope.row.status == 2">待确认</span>
                              <span v-if="scope.row.status == 3">待发货</span>
                              <span v-if="scope.row.status == 4">已发货</span>
                              <span v-if="scope.row.status == 5">确认收货</span>
                              <span v-if="scope.row.status == 6">驳回</span>
                              <span v-if="scope.row.status == 7">已撤单</span>
                            </div>
                          </template>
                        </el-table-column>
                      <el-table-column
                          prop="sapCode"
                          :show-overflow-tooltip="true"
                          width="120"
                          label="45码">
                      </el-table-column>
                      <el-table-column
                          prop="purchaseOrgCode"
                          :show-overflow-tooltip="true"
                          width="100"
                          label="采购公司">
                      </el-table-column>
                      <el-table-column
                          prop="lgort"
                          :show-overflow-tooltip="true"
                          width="100"
                          label="库位">
                      </el-table-column>
                      <el-table-column
                          prop="suserName"
                          :show-overflow-tooltip="true"
                          width="160"
                          label="供应商名称">
                      </el-table-column>
                      <el-table-column
                          prop="suserCode"
                          :show-overflow-tooltip="true"
                          width="100"
                          label="供应商编码">
                      </el-table-column>
                      <el-table-column
                          prop="cuname"
                          :show-overflow-tooltip="true"
                          width="120"
                          label="创建人名称">
                      </el-table-column>
                      <el-table-column
                          prop="cucode"
                          :show-overflow-tooltip="true"
                          width="120"
                          label="创建人编码">
                      </el-table-column>
                      <el-table-column
                          prop="cdate"
                          :show-overflow-tooltip="true"
                          width="120"
                          value-format="yyyy-MM-dd"
                          label="创建时间">
                      </el-table-column>
                      <el-table-column
                          prop="shenhetime"
                          :show-overflow-tooltip="true"
                          width="120"
                          value-format="yyyy-MM-dd"
                          label="审核通过时间">
                      </el-table-column>
                      <el-table-column
                          prop="fhdate"
                          :show-overflow-tooltip="true"
                          width="120"
                          value-format="yyyy-MM-dd"
                          label="发货日期">
                      </el-table-column>
                      <el-table-column
                          prop="shdate"
                          :show-overflow-tooltip="true"
                          width="120"
                          value-format="yyyy-MM-dd"
                          label="收货日期">
                      </el-table-column>
                      <el-table-column
                          prop="paymentProportion"
                          :show-overflow-tooltip="true"
                          width="120"
                          label="付款比例">
                      </el-table-column>
                      <el-table-column
                          prop="payType"
                          :show-overflow-tooltip="true"
                          width="120"
                          label="付款状态">
                        <template slot-scope="scope">
                          <div>
                            <span v-if="scope.row.payType == 0">未付款</span>
                            <span v-if="scope.row.payType == 1">付款中</span>
                            <span v-if="scope.row.payType == 2">付款完成</span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="specialOfferCode"
                          :show-overflow-tooltip="true"
                          width="180"
                          label="特价版本">
                      </el-table-column>
                      <el-table-column
                        prop="confirmedTime"
                        :show-overflow-tooltip="true"
                        width="120"
                        value-format="yyyy-MM-dd"
                        label="确认日期">
                    </el-table-column>
                      <el-table-column
                        prop="invoiceDate"
                        :show-overflow-tooltip="true"
                        value-format="yyyy-MM-dd"
                        width="120"
                        label="开票日期">
                    </el-table-column>
                      <el-table-column
                        prop="createTimeInvoice"
                        :show-overflow-tooltip="true"
                        value-format="yyyy-MM-dd"
                        width="120"
                        label="发票创建日期">
                    </el-table-column>
                      <el-table-column
                          prop="ifCheck"
                          :show-overflow-tooltip="true"
                          width="120"
                          label="发票状态">
                        <template slot-scope="scope">
                          <div>
                            <span v-if="scope.row.ifCheck == 1">审核中</span>
                            <span v-if="scope.row.ifCheck == 0">未提报</span>
                            <span v-if="scope.row.ifCheck == 2">审核通过</span>
                            <span v-if="scope.row.ifCheck == 3">驳回</span>
                          </div>
                        </template>
                      </el-table-column>
<!--                        <el-table-column
                                fixed="right"
                                label="操作"
                                width="70">
                            <template slot-scope="scope">
                                <div class="w-caozuo" style="text-align: left;">
                                    <el-button
                                            type="text"
                                            size="small"
                                            class="h-tableLink h-btn" @click="update(scope.row)">
                                        修改
                                    </el-button>
                                </div>
                            </template>
                        </el-table-column>-->
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                       @click="exportExcel">批量导出
                            </el-button>
                            <uploaddownexcel
                                    :visible.sync="uploaddownexcelflag"
                                    v-if="uploaddownexcelflag"
                                    clsname="bscPartnerHighSeasExcel"
                                    :startrow="2"
                                    :extparams="q"
                                    @callback="uploadExcelFilecallback"/>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="query"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import updownfile from '../../utils/updownfile'
    import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'
    import ss from '../../api/SystemService'
    import searchInvoice from './searchInvoice'

    export default {
        components: {
            uploaddownexcel,
        },
        data() {
            return {
                //表格
                multipleSelection: [],
                canjobpoint:true,
                isImport:false,
                //导入Excel
                uploaddownexcelflag: false,
                //新增/修改弹窗
                saveorupdate: null,
                areaList:[],
                channelList:[],
                //临时的id
                iditem:'',
                userInfo: {
                    usercode: null,
                    username: null,
                },
                //分页/检索
                q:{
                  billNo:null,
                  supplierCode:null,
                  invoiceNumber:null,
                  companyCode:null,
                  staDate : '',
                  endDate : '',
                  pageSize: 10,
                  pageNo: 1,
                  total: 0,
                },
                //链群
                JobGroup: [],
                JobPoint:[],
                //table列表
                tableData: [],
                //弹窗
                dialogFormVisible: false,
            }
        },
        created() {
            this.query();
            this.selectJobGroup();
            this.channelList = this.$store.getters.dictlist("sales_region");
            this.areaList = this.$store.getters.dictlist("YLRegion");
            this.isImport = this.$store.getters.hasRole('swyl_admin,swyl_wanglgly');
            this.checkTime();
        },
        methods: {
            //部门列表
            selectJobGroup() {
                ss.xietongguanli.selectDeptPoint().then(rd => {
                    this.JobGroup = rd;
                });
            },
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
            //重置检索项
            resetData() {
                this.q.customerCode = null;
                this.q.area = null;
                this.q.channel = null;
                this.q.user = null;
            },
            query() {
              var data = this.q;
              ss.invoiceApplyList.selectInvoiceTheEnd(data).then(rd => {
                this.tableData = rd.records;
                this.q.total = rd.total
              });
            },
            //勾选
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //删除
            handleDelete(value) {
                this.$msg.confirm("确认删除?", () => {
                    ss.xietongguanli.deleteDept(value.id).then(rd => {
                        this.query();
                        this.$msg.msgs(rd.msg);
                    });
                });
            },
          //获取日期
            checkTime(){
              var now = new Date();
              // 先获取当前时间
              var curDate = (new Date()).getTime()
              // 将半年的时间单位换算成毫秒
              var halfYear = 365 / 12 * 24 * 3600 * 1000
              // 半年前的时间（毫秒单位）
              var pastResult = curDate - halfYear
              // 日期函数，定义起点为半年前
              var pastDate = new Date(pastResult)
              var pastYear = pastDate.getFullYear()
              var pastMonth = pastDate.getMonth() + 1
              var pastDay = pastDate.getDate()
              if (pastMonth >= 1 && pastMonth <= 9) {
                pastMonth = '0' + pastMonth
              }
              if (pastDay >= 0 && pastDay <= 9) {
                pastDay = '0' + pastDay
              }
              var endDate = pastYear + '-' + pastMonth + '-' + pastDay
              this.q.endDate = now;
              this.q.staDate = endDate;
            },
            //批量导出
            exportExcel() {
                updownfile.down("/api/swyl/v1/demo/bscSrmInvoiceDetail/downloadExceTheEndl", this.q, "get",);
            }
        }
    }
</script>

<style>
    .yonghu .h-formbLine .h-elformWrap-2 {
        width: 50%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__label {
        width: 41%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__content {
        width: 59%;
    }

    .yonghu .h-formbLine .el-form-item__content .el-select {
        width: 100% !important;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    }
    .el-table tbody td:last-child{
        border-left: 1px solid #c2d2db;
    }
</style>
